/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */

import config from 'src/js/support/config';
import {
  REQUEST_CREATE_SITE,
  REQUEST_CREATE_SITE_SUCCESS,
  REQUEST_CREATE_SITE_FAILURE,
} from 'constants/actionTypes';
import apiBaseUrl from 'support/apiBaseUrl';

const axios = require('axios');
/**
 * Returns a REQUEST_CREATE_SITE action
 */
const requestCreateSite = () => (
  {
    type: REQUEST_CREATE_SITE,
  }
);

/**
 * Returns a REQUEST_CREATE_SITE_SUCCESS action
 * @param data
 */
const requestCreateSiteSuccess = data => (
  {
    type: REQUEST_CREATE_SITE_SUCCESS,
    data,
  }
);

/**
 * Returns a REQUEST_CREATE_SITE_FAILURE action
 */
const requestCreateSiteFailure = error => (
  {
    type: REQUEST_CREATE_SITE_FAILURE,
    error,
  }
);

export const createSite = (body, userId, token) => (dispatch) => {
  dispatch(requestCreateSite());
  const options = {
    url: `${apiBaseUrl(config)}/users/${userId}/reports`,
    headers: {
      Authorization: `bearer ${token}`,
      'Content-Type': 'application/json',
    },
    method: 'post',
    data: body,
  };
  return axios(options)
    .then((response) => {
      dispatch(requestCreateSiteSuccess(response.data));
    }).catch(() => {
      dispatch(requestCreateSiteFailure(new Error('There was a problem with your request')));
    });
};
